import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@svs/ui/react/button';
import { useState } from 'react';
/**
 * Show/Hide button with toggle functionality.
 *
 * @param root0 input object props
 * @param root0.className optional class name for styling
 * @param root0.showValue the value to show when visible
 * @param root0.hideValue the value to show when hidden
 * @param root0.variant optional variant for button styling
 * @param root0.Icon optional icon component to display
 * @param root0.onClick optional click handler
 * @returns toggle button for showing/hiding values
 */
export default function ShowHideButton(t0) {
  const $ = _c(10);
  const {
    className,
    showValue,
    hideValue,
    Icon,
    variant,
    onClick
  } = t0;
  const [isVisible, setIsVisible] = useState(false);
  let t1;
  if ($[0] !== onClick) {
    t1 = () => {
      onClick?.();
      setIsVisible(_temp);
    };
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  const t2 = variant ?? "primary";
  let t3;
  if ($[2] !== Icon || $[3] !== className || $[4] !== handleClick || $[5] !== hideValue || $[6] !== isVisible || $[7] !== showValue || $[8] !== t2) {
    t3 = _jsxs(Button, {
      type: "button",
      "aria-pressed": isVisible,
      className,
      onClick: handleClick,
      variant: t2,
      children: [Icon && _jsx(Icon, {
        className: "h-[20px] w-[20px]",
        "aria-hidden": "true"
      }), isVisible ? showValue : hideValue]
    });
    $[2] = Icon;
    $[3] = className;
    $[4] = handleClick;
    $[5] = hideValue;
    $[6] = isVisible;
    $[7] = showValue;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(_isVisible) {
  return !_isVisible;
}